const Utils = {
  getScript: function (url, op) {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.async = true // for firefox3.6
    if (!op) { op = {} } else if (op instanceof Function) { op = { callback: op } }
    if (op.charset) { s.charset = op.charset }
    if (op.crossOrigin) {
      s.crossOrigin = true
    }
    s.src = url
    const h = document.getElementsByTagName('head')[0]
    let done = false
    s.onload = s.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true
        // 防止ie内存泄漏
        s.onload = s.onreadystatechange = null
        if (!op.saveScript) { h.removeChild(s) }
        if (op.callback) { op.callback() }
      }
    }
    h.appendChild(s)
  },

  imageOss: function (url, size) {
    // oss域名白名单排除
    if (url.indexOf('/vthumb.ykimg.com/') > -1 || url.indexOf('.gif') > -1) {
      return url
    }
    let s = size || 290
    if (url.indexOf('x-oss-process') > -1) {
      return url
    } else if (url.indexOf('?') > -1) {
      return url + '&x-oss-process=image/resize,w_' + s + '/interlace,1/quality,Q_100/sharpen,100'
    } else {
      return url + '?x-oss-process=image/resize,w_' + s + '/interlace,1/quality,Q_100/sharpen,100'
    }
  },

  getSpmD: function (index, extStr) {
    extStr = extStr || ''
    return index < 10 ? `d_${extStr}0${index}` : `d_${extStr}${index}`
  },

  getSpmC: function (data) {
    if (!data) {
      return ''
    }
    if (data.moduleId) {
      return `m_${data.moduleId}`
    } else if (data.mid && data.cid) {
      return `m_${data.mid}_c_${data.cid}`
    }
    return ''
  },

  getSpmAB () {
    if (!__isBrowser__) {
      return {}
    }
    return window.spmData || {}
  },

  /**
   * dom节点点击的时候的埋点发送
   * @param {domElement} el
   */
  sendClickLog (el, trackInfo) {
    const dataset = el.dataset || {}
    if (!trackInfo) {
      trackInfo = dataset.trackinfo ? JSON.parse(dataset.trackinfo) : {}
    }
    const exargs = [{
      exargs: {
        'data-spm': dataset.spm,
        'data-mname': trackInfo.drawer,
        'data-cname': trackInfo.component_title,
        'data-cid': trackInfo.component_id,
        'data-mid': trackInfo.drawerid,
        'data-trackinfo': encodeURIComponent(dataset.trackinfo)
      },
      'spm': dataset.spmAnchorId,
      'scm': dataset.scm,
      'aplusContentId': ''
    }]
    const _param = {
      clkdata: JSON.stringify(exargs)
    }
    const arr = []
    for (let key in _param) {
      arr.push(`${key}=${_param[key]}`)
    }
    var q = (window.goldlog_queue || (window.goldlog_queue = []))
    q.push({
      action: 'goldlog.record',
      arguments: ['/yt/click.index.module', 'CLK', arr.join('&'), 'POST']
    })
  }
}
export default Utils
